export default __webpack_public_path__ + "static/software-development-company-movie-3fc7087135a476846032874a56b0c1d4.webm";